import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { toJS } from 'mobx';
import util from 'preact-util';
import { Text, Localizer } from 'preact-i18n';
import linkstate from 'linkstate';

import Input from '../../components/form/input';

@observer
class AddArrayObject extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            foundList: [],
            updateInProgress: {},
            activeHelpField: null,
        };
    }

    toggleHelpTooltip = (e, fieldName) => {
        e.preventDefault();
        e.stopPropagation();
        const { activeHelpField } = this.state;
        this.setState({ activeHelpField: activeHelpField === fieldName ? null : fieldName });
    }

    setUpdateInProgress = (field, value) => {
        const { updateInProgress } = this.state;
        this.setState({
            updateInProgress: {
                ...updateInProgress,
                [field]: value,
            },
        });
    }

    onInput = e => {
        const {
            holdingStore,
            field,
            object,
            md5,
            uuidv4,
        } = this.props;
        const { newObject } = holdingStore;
        const { name, value, type } = e.target;

        this.setUpdateInProgress(`${md5}-${name}`, true);
        // console.log('onInput', { name, value, field, id: object.id, md5 });
        holdingStore.updateObjectKeyValue('newObject', name, value);

        clearTimeout(this.updateTimer);
        // Capture value immediately - DOM element's value attribute may change after re-render
        const capturedName = name;
        const capturedValue = value;
        const capturedType = type;
        this.updateTimer = setTimeout(() => {
            this.doUpdate({ name: capturedName, value: capturedValue, type: capturedType });
        }, 1000);
    }

    doUpdate = async ({ name, value, type }) => {
        const {
            holdingStore,
            field,
            object,
            objectName,
            md5,
            uuidv4,
            isAdmin,
        } = this.props;
        const { newObject } = holdingStore;
        // console.log('doUpdate', { name, value, field, id: object.id, md5, objectName });
        // holdingStore.updateObjectKeyValue('newObject', name, value);
        await holdingStore.editArrayObject({
            field,
            key: name,
            value,
            type,
            id: object.id,
            md5,
            uuidv4,
            objectName,
            isAdmin,
        });
        this.setUpdateInProgress(`${md5}-${name}`, false);
    }

    save = () => {
        const {
            after = () => {},
            drawerLevel,
        } = this.props;
        const { appState } = this.props.stores;
        after();
        appState.toggleDrawer(false, drawerLevel);
    };

    selectElement = (e) => {
        const { holdingStore } = this.props;
        const { newObject } = holdingStore;
        const resultObject = { ...newObject };
        const { foundList } = this.state;
        const { idx } = e.target.closest('.similar-item').dataset;
        const element = foundList[idx];
        if (element) {
            const keys = Object.keys(element);
            keys.forEach((key) => {
                resultObject[key] = element[key];
            });
            holdingStore.updateKeyValue('newObject', resultObject);
            this.setState({
                search: '',
                foundList: [],
            });
        }
    }

    searchInput = (e) => {
        const search = e.target.value;
        const { newObject } = this.state;
        const {
            fieldObject,
            holdingStore,
            lookupArray,
        } = this.props;

        const listName = lookupArray || fieldObject.lookupArray;
        let foundListKeys = [];
        let foundList = [];
        if (listName) {
            const list = holdingStore[listName];
            if (list) {
                foundListKeys = list[0] ? Object.keys(list[0]) : [];
            }
            const matchKeys = (item, regExp) => {
                return foundListKeys.some((key) => {
                    // console.log('key', key, item[key], regExp.test(item[key]));
                    if (regExp.test(item[key])) {
                        return true;
                    }
                });
            };
            if (list && search) {
                const regExp = new RegExp(search, 'i');
                foundList = list.filter(item => matchKeys(item, regExp)).map(item => {
                    return item;
                });
            }
        }
        // console.log('foundList', foundList)
        this.setState({ search, foundList, foundListKeys });
    }

    componentDidMount() {
        const { holdingStore, object, field, md5 } = this.props;
        const newObject = object[field].find(e => e.md5 === md5);
        holdingStore.updateKeyValue('newObject', newObject);
    }

    render() {
        const { search, foundList, foundListKeys, updateInProgress = {}, activeHelpField } = this.state;
        const {
            before = () => {},
            after = () => {},
            isNew,
            field,
            fieldObject,
            type,
            min,
            maxValue,
            step,
            elementtype,
            datalist,
            object,
            holdingStore,
            lookupArray,
            md5,
            datalistHelp,
            datalistValues,
            toggleFields = [],
        } = this.props;

        const { newObject } = holdingStore;

        const newValue = parseInt(newObject[field] || newObject.id, 10);
        const listName = fieldObject.lookupArray;
        let found;
        let foundValue;
        if (listName) {
            const list = holdingStore[listName];
            // console.log('list', list);
            if (list) {
                found = list.find((item) => item.id === newValue);
                foundValue = fieldObject.displayValue && found ? fieldObject.displayValue(found) : JSON.stringify(found, null, 2);
            }
        }

        const { userStore } = this.props.stores;
        const { user } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 20px;'>

                    <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                        <Text id='form.edit'>Edit</Text> {field}
                    </div>

{/* <xmp>{JSON.stringify({
    isNew,
    field,
    fieldObject,
    type,
    min,
    maxValue,
    step,
    elementtype,
    datalist,
    object,
    holdingStore,
    lookupArray,
    md5,
}, null, 4)}</xmp> */}


                    <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between'>
                        {listName && <div class='w-100 mb-3'>
                            <input
                                class='inputForm form-control form-control-lg py-0 w-100'
                                type='text'
                                placeholder={'search'}
                                onInput={this.searchInput}
                            />
                        </div>}
                    </div>

                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(datalist, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(holdingStore, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(search, null, 4)}</xmp> */}
                    {/* <xmp>{JSON.stringify(foundList, null, 4)}</xmp> */}
                    {/* // <xmp>{JSON.stringify(newObject, null, 4)}</xmp> // */}
                    {/* fieldObject: <xmp>{JSON.stringify(fieldObject, null, 4)}</xmp> */}
                    {foundList && foundList.length > 0 && <>
                        <div class='font-weight-lighter px-3 py-1 text-muted' >
                            <small class='text-uppercase'>
                                <Text id='form.search-result'>Search results</Text>
                            </small>
                        </div>
                        <div class={`d-flex flex-column mx-3 mb-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}>
                            {foundList.map((el, idx) => (<>
                                <div
                                    class='d-flex flex-row justify-content-between align-items-center similar-item'
                                    data-idx={idx}
                                    onClick={this.selectElement}
                                >
                                    {foundListKeys && foundListKeys.length > 0 && foundListKeys.map(field => (<>
                                        <div class='flex-fill py-2 px-3'>
                                            <span class='font-weight-lighter text-muted'>{field}:</span> {el[field]}
                                        </div>
                                    </>))}
                                </div>
                            </>))}
                        </div>
                    </>}

                    <div class={`compact-form-container mx-3 rounded-lg ${darkmode ? 'bg-darkmode darkmode' : 'bg-lightmode'}`}>
                        <div class='compact-field-table'>
                            {datalist && datalist.length > 0 ? datalist.map((el, idx) => {
                                const help = datalistHelp && datalistHelp[el] ? datalistHelp[el] : '';
                                return (
                                    <div class='compact-field-row'>
                                        <div class='compact-field-label-cell' style='width: 140px; max-width: 140px; min-width: 140px;'>
                                            <div class='compact-field-label-content'>
                                                {el}
                                                {help && (
                                                    <span
                                                        class={`compact-help-icon ${activeHelpField === el ? 'active' : ''}`}
                                                        onClick={(e) => this.toggleHelpTooltip(e, el)}
                                                    >
                                                        <i class='fa-solid fa-circle-info' style='font-size: 10px;' />
                                                        <span class={`compact-help-tooltip ${activeHelpField === el ? 'show' : ''}`}>
                                                            {help}
                                                            <button
                                                                class='compact-help-close'
                                                                onClick={(e) => { e.stopPropagation(); this.setState({ activeHelpField: null }); }}
                                                            >
                                                                <i class='fa-solid fa-times' />
                                                            </button>
                                                        </span>
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div class='compact-field-input-cell'>
                                            <div class='compact-input-wrapper'>
                                                <Input
                                                    stores={this.props.stores}
                                                    holdingStore={holdingStore}
                                                    objectName={'newObject'}
                                                    object={newObject}
                                                    type={el === 'image' ? 'image' : (el === 'json' ? 'textarea' : (toggleFields.includes(el) ? 'toggle' : 'text'))}
                                                    field={el}
                                                    min={min}
                                                    max={maxValue}
                                                    step={step}
                                                    name={field}
                                                    value={newObject[el]}
                                                    title={''}
                                                    placeholder={el}
                                                    onInput={this.onInput}
                                                    updateInProgress={updateInProgress[`${newObject.md5}-${el}`]}
                                                    classNames='compact-input'
                                                    skipSurroundingDivs={true}
                                                />
                                                {updateInProgress[`${newObject.md5}-${el}`] && (
                                                    <span class='compact-indicator'>
                                                        <span class='compact-update-indicator' />
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            }) : <>
                                <div class='compact-field-row'>
                                    <div class='compact-field-label-cell' style='width: 140px; max-width: 140px; min-width: 140px;'>
                                        <div class='compact-field-label-content'>{field}</div>
                                    </div>
                                    <div class='compact-field-input-cell'>
                                        <div class='compact-input-wrapper'>
                                            <Input
                                                stores={this.props.stores}
                                                holdingStore={holdingStore}
                                                objectName={'newObject'}
                                                object={newObject}
                                                type={field === 'image' ? 'image' : (field === 'json' ? 'textarea' : 'text')}
                                                field={field}
                                                min={min}
                                                max={maxValue}
                                                step={step}
                                                name={field}
                                                value={newObject[field]}
                                                title={''}
                                                placeholder={field}
                                                onInput={this.onInput}
                                                updateInProgress={updateInProgress[`${newObject.md5}-${field}`]}
                                                classNames='compact-input'
                                                skipSurroundingDivs={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>}
                        </div>
                    </div>

                    <div class={`w-100 ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} d-flex flex-column justify-content-start py-3 px-3`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.save}><Text id='form.save'>Save</Text> {field}</button>
                    </div>
                </div>
            </div>
        </>);
    }
}

export default AddArrayObject;
